import React from 'react';
import useAuth from '../hooks/useAuth';
import { AdminRouter } from './admin-router';
import { ClientAdminRouter, ClientOnboardingRouter } from './clientadmin-router';
import { UserRole } from '../containers/navigation-bar/roles';
import { WrongUserRouter } from './wrong-user-router';
import { useVersionedRecordAcceptance } from '../hooks/useVersionedRecords';
import { VersionedRecordKey } from '../hooks/useVersionedRecords';

const AuthenticatedRouter: React.FC = () => {
  /*
    check what type of role we have and adjust routes accordingly
  */
  const { user, roleType } = useAuth();
  const { data: termsOfServiceAcceptance } = useVersionedRecordAcceptance(
    VersionedRecordKey.CLIENT_ADMIN_TERMS_OF_SERVICE,
  );
  const { data: privacyPolicyAcceptance } = useVersionedRecordAcceptance(
    VersionedRecordKey.CLIENT_ADMIN_PRIVACY_POLICY,
  );
  const termsAndPrivacyAccepted = termsOfServiceAcceptance?.accepted && privacyPolicyAcceptance?.accepted;

  const renderRouter = (): React.ReactElement => {
    /* Note: hasCompletedOnboarding will default to true if the user doesn't have an admin or client admin role.
    Separately, we need to check if the user has accepted the versioned record for Client Admin TOS. 
    A user who has completed onboarding as a caller or listener would be able to log in without accepting the ToS otherwise,
    because they would havee `hasCompletedOnboarding` set to true and already has a client_administrator_role (created during invitation).
    */
    if ((!user?.hasCompletedOnboarding || !termsAndPrivacyAccepted) && user?.client_administrator_role_id) {
      return <ClientOnboardingRouter />;
    }
    // admin
    if (roleType === UserRole.admin) {
      return <AdminRouter />;
    }
    // client admin
    if (roleType === UserRole.client_admin) {
      return <ClientAdminRouter />;
    }
    // you don't have any roles that fit what matches this app :(
    // could look for listener_role or caller_role here if desired
    return <WrongUserRouter />;
  };

  return <>{renderRouter()}</>;
};

export default AuthenticatedRouter;
